import { NgModule } from "@angular/core";
import { DirectHeaderComponent } from "./branded-direct-header/direct-header.component";
import { DirectFooterComponent } from "./direct-footer/direct-footer.component";
import { DirectRandomFactsComponent } from "./branded-direct-random-facts/direct-random-facts.component";


@NgModule({
    declarations: [
    ],
    imports: [
        DirectHeaderComponent,
        DirectFooterComponent,
        DirectRandomFactsComponent
    ],
    exports: [
        DirectHeaderComponent,
        DirectFooterComponent,
        DirectRandomFactsComponent,
    ]
})

export class BrandingLayoutModule{

}